import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-bg" }
const _hoisted_2 = { class: "navbar" }
const _hoisted_3 = { class: "restaurant-selector" }
const _hoisted_4 = {
  key: 0,
  disabled: ""
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex items-center mr-4" }
const _hoisted_8 = {
  key: 0,
  class: "text-white mr-2 text-lg"
}
const _hoisted_9 = { class: "nav-dropdown mr-3" }
const _hoisted_10 = { class: "legend-bar" }
const _hoisted_11 = { class: "legend-time" }
const _hoisted_12 = { class: "table-grid-wrap" }
const _hoisted_13 = { class: "table-grid" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "table-title" }
const _hoisted_18 = { class: "table-status" }
const _hoisted_19 = { class: "table-info" }
const _hoisted_20 = {
  key: 0,
  class: "table-info-row"
}
const _hoisted_21 = {
  key: 1,
  class: "table-info-row"
}
const _hoisted_22 = {
  key: 2,
  class: "occupied-info"
}
const _hoisted_23 = { class: "table-info-row-occupied" }
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = { class: "table-info-row-occupied" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = { class: "table-info-row-occupied text-xs" }
const _hoisted_28 = { class: "flex items-center" }
const _hoisted_29 = { class: "amount-text text-green-600" }
const _hoisted_30 = {
  key: 3,
  class: "reserved-info"
}
const _hoisted_31 = {
  key: 4,
  class: "disabled-info"
}
const _hoisted_32 = {
  key: 5,
  class: "cleaning-info"
}
const _hoisted_33 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_34 = { class: "modal-content" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "text-xl font-semibold mb-2" }
const _hoisted_37 = { class: "progress-bar-container" }
const _hoisted_38 = { class: "text-sm text-gray-500 mt-2" }
const _hoisted_39 = {
  key: 1,
  class: "modal-overlay"
}
const _hoisted_40 = { class: "modal-content" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-xl font-semibold mb-2" }
const _hoisted_43 = { class: "progress-bar-container" }
const _hoisted_44 = { class: "text-sm text-gray-500 mt-2" }

import { onMounted, ref, onUnmounted } from 'vue';
  import { fetchShopList } from '@/service/base';
  import { getOrderTableList, auditOrder, completeOrder } from '@/service/order';
  import { OrderTableListItemModel } from '@/model/order';
  import { useRouter } from 'vue-router';
  import { useCurrentEmployee } from '@/composables/useCurrentEmployee';
  const SELECTED_SHOP_KEY = 'table_manage_selected_shop';

  // 保存选中的店铺到localStorage
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TableManageView',
  setup(__props) {

  const router = useRouter();
  const { employeeId: currentEmployeeId } = useCurrentEmployee();

  const shopList = ref<any[]>([]);
  const selectedShopId = ref<number | null>(null);
  const orderTableList = ref<Array<OrderTableListItemModel>>([]);
  const isTableNavigationPending = ref(false);
  let latestTableListRequestId = 0;

  // localStorage key for selected shop
  const saveSelectedShop = (shopId: number) => {
    try {
      localStorage.setItem(SELECTED_SHOP_KEY, shopId.toString());
    } catch (e) {
      console.error('保存选中店铺失败:', e);
    }
  };

  // 从localStorage读取选中的店铺
  const loadSelectedShop = () => {
    try {
      return localStorage.getItem(SELECTED_SHOP_KEY);
    } catch (e) {
      console.error('读取选中店铺失败:', e);
      return null;
    }
  };

  // 翻台相关状态
  const showFlipProgress = ref(false);
  const currentFlipTable = ref<OrderTableListItemModel | null>(null);
  const flipProgress = ref(0);
  const flipProgressText = ref('');

  // 确认订单相关状态
  const showConfirmProgress = ref(false);
  const currentConfirmTable = ref<OrderTableListItemModel | null>(null);
  const confirmProgress = ref(0);
  const confirmProgressText = ref('');

  // 导航菜单状态
  const showNavMenu = ref(false);

  // 定时器相关状态
  const lastRefreshTime = ref('');
  let autoRefreshTimer: NodeJS.Timeout | null = null;

  // 获取桌位列表
  const fetchOrderTableList = async (shopId: number) => {
    const requestId = ++latestTableListRequestId;
    const respOrderTables = await getOrderTableList({
      pageNum: 1,
      pageSize: 999,
      data: {
        shopId: shopId,
      },
    });
    if (
      respOrderTables.code === 200 &&
      requestId === latestTableListRequestId &&
      selectedShopId.value === shopId
    ) {
      orderTableList.value = respOrderTables.result.list;
    }
  };

  const onShopChange = async () => {
    if (selectedShopId.value !== null) {
      // 保存选中的店铺到localStorage
      saveSelectedShop(selectedShopId.value);
      // 切换店铺后立即清空旧桌位，避免新请求返回前误点旧店铺桌位
      orderTableList.value = [];
      await fetchOrderTableList(selectedShopId.value as number);
    }
  };

  const refreshTableStatus = async () => {
    if (selectedShopId.value !== null) {
      await fetchOrderTableList(selectedShopId.value as number);
      // 更新刷新时间
      updateRefreshTime();
      showToast('刷新成功');
    }
  };

  // 根据 shopId 获取店铺名称
  const getShopNameById = (id?: number) => {
    if (!id) return '';
    const shop = shopList.value.find((s) => s.shopId === id);
    return shop?.shopName || '';
  };

  // 更新刷新时间
  const updateRefreshTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    lastRefreshTime.value = `${hours}:${minutes}:${seconds}`;
  };

  // 启动自动刷新定时器
  const startAutoRefresh = () => {
    // 清除现有定时器
    if (autoRefreshTimer) {
      clearInterval(autoRefreshTimer);
    }

    // 设置10秒定时器
    autoRefreshTimer = setInterval(async () => {
      if (selectedShopId.value !== null) {
        await fetchOrderTableList(selectedShopId.value as number);
        updateRefreshTime();
        console.log('自动刷新完成:', lastRefreshTime.value);
      }
    }, 10000); // 10秒
  };

  // 停止自动刷新定时器
  const stopAutoRefresh = () => {
    if (autoRefreshTimer) {
      clearInterval(autoRefreshTimer);
      autoRefreshTimer = null;
    }
  };

  // 点击外部关闭菜单
  const handleClickOutside = (event: Event) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-dropdown')) {
      showNavMenu.value = false;
    }
  };

  onMounted(async () => {
    const respShop = await fetchShopList({ pageNum: 1, pageSize: 100, data: { shopStatus: 0 } });
    if (respShop.code === 200 && respShop.result.list.length > 0) {
      shopList.value = respShop.result.list;

      // 尝试从localStorage恢复店铺选择
      const savedShopId = loadSelectedShop();
      if (savedShopId && shopList.value.some((shop) => shop.shopId.toString() === savedShopId)) {
        selectedShopId.value = parseInt(savedShopId);
      } else {
        // 如果没有保存的店铺或保存的店铺不存在，使用第一个店铺
        selectedShopId.value = shopList.value[0].shopId;
      }

      await fetchOrderTableList(selectedShopId.value as number);

      // 初始化刷新时间并启动自动刷新
      updateRefreshTime();
      startAutoRefresh();
    }

    // 添加点击外部关闭菜单的事件监听
    document.addEventListener('click', handleClickOutside);
  });

  // 组件卸载时清理定时器和事件监听
  onUnmounted(() => {
    stopAutoRefresh();
    document.removeEventListener('click', handleClickOutside);
  });

  const toggleNavMenu = () => {
    showNavMenu.value = !showNavMenu.value;
  };

  const goToDishAssignment = () => {
    router.push('/dishAssignment');
    showNavMenu.value = false; // 关闭菜单
  };

  const goToKitchen = () => {
    router.push('/kitchenOrder');
    showNavMenu.value = false; // 关闭菜单
  };

  const goToHistory = () => {
    router.push('/servingHistory');
    showNavMenu.value = false; // 关闭菜单
  };

  const goToOrderHistory = () => {
    router.push('/orderHistory');
    showNavMenu.value = false; // 关闭菜单
  };

  const goToTableManage = () => {
    router.push('/tableManage');
    showNavMenu.value = false; // 关闭菜单
  };

  const goToFoodManage = () => {
    router.push('/foodManage');
    showNavMenu.value = false; // 关闭菜单
  };

  const toggleLanguage = () => {
    showToast('语言切换功能将在下一版本推出');
  };

  // 获取桌位状态对应的CSS类
  const getTableStatusClass = (tableStatus: number | undefined) => {
    switch (tableStatus) {
      case 0: // 尚未点餐
        return 'available';
      case 1: // 已点餐
      case 2:
      case 8:
        return 'ordered';
      case 3: // 已禁用
        return 'disabled';
      case 4: // 清理中
        return 'cleaning';
      case 5: // 待确认
        return 'occupied';
      case 6: // 用餐中
        return 'occupied';
      case 10: // 已预订
        return 'reserved';
      default:
        return 'available';
    }
  };

  // 获取状态图标
  const getStatusIcon = (tableStatus: number | undefined) => {
    switch (tableStatus) {
      case 0: // 尚未点餐
        return 'fas fa-utensils text-blue-500 mr-1';
      case 1: // 已点餐
      case 2:
      case 8:
        return 'fas fa-check-circle text-green-500 mr-1';
      case 10: // 已预订
        return 'fas fa-calendar-alt text-yellow-500 mr-1';
      case 3: // 已禁用
        return 'fas fa-ban text-gray-500 mr-1';
      case 4: // 清理中
        return 'fas fa-broom text-pink-500 mr-1';
      case 5: // 待确认
        return 'fas fa-clock text-orange-500 mr-1';
      default:
        return 'fas fa-utensils text-blue-500 mr-1';
    }
  };

  // 获取状态文本
  const getStatusText = (tableStatus: number | undefined) => {
    switch (tableStatus) {
      case 0:
        return '尚未点餐';
      case 1:
        return '已点餐';
      case 10:
        return '已预订';
      case 3:
        return '已禁用';
      case 4:
        return '清理中';
      case 5: // 待确认
        return '待确认';
      case 6: // 用餐中
        return '用餐中';
      case 8:
        return '已出餐';
      default:
        return '未知状态';
    }
  };

  // 判断是否是已占用桌位（已点餐、用餐中等）
  const isOccupiedTable = (table: OrderTableListItemModel) => {
    return table.tableStatus && [1, 2, 5, 6, 8].includes(table.tableStatus);
  };

  // 获取用餐人数
  const getPersonCount = (table: OrderTableListItemModel) => {
    if (table.orderSelectResp) {
      return table.orderSelectResp.personCount || 4;
    }
    return 4;
  };

  // 获取订单总金额
  const getTotalAmount = (table: OrderTableListItemModel) => {
    if (table.orderSelectResp) {
      return table.orderSelectResp.totalAmount || 0;
    }
    return 0;
  };

  // 获取开台时间
  const getOpenTime = (table: OrderTableListItemModel) => {
    if (table.orderSelectResp && table.orderSelectResp.openTime) {
      const openTime = new Date(table.orderSelectResp.openTime);
      const hours = String(openTime.getHours()).padStart(2, '0');
      const minutes = String(openTime.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}开台`;
    }
    return '刚刚开台';
  };

  // 获取订单状态图标
  const getOrderStatusIcon = (table: OrderTableListItemModel) => {
    if (table.tableStatus === 5) {
      return 'fas fa-hourglass-half text-orange-500 mr-1';
    } else if (table.tableStatus === 1 || table.tableStatus === 2) {
      return 'fas fa-utensils text-blue-500 mr-1';
    } else if (table.tableStatus === 8) {
      return 'fas fa-utensils text-green-500 mr-1';
    }
    return 'fas fa-clock text-blue-500 mr-1';
  };

  // 获取订单状态文本
  const getOrderStatusText = (table: OrderTableListItemModel) => {
    if (table.tableStatus === 5) {
      return '等待确认';
    } else if (table.tableStatus === 1 || table.tableStatus === 2) {
      return '制作中';
    } else if (table.tableStatus === 8) {
      return '已上菜完成';
    }
    return '制作中';
  };

  // 获取支付状态图标
  const getPaymentStatusIcon = (table: OrderTableListItemModel) => {
    const paymentStatus = table.orderSelectResp?.paymentStatusName?.toLowerCase() || '';

    // 已支付状态显示绿色图标
    if (
      paymentStatus.includes('已支付') ||
      paymentStatus.includes('支付成功') ||
      paymentStatus.includes('paid') ||
      paymentStatus.includes('success')
    ) {
      return 'fas fa-check-circle text-green-500 mr-1';
    }

    // 待支付或部分支付显示红色图标
    if (
      paymentStatus.includes('待支付') ||
      paymentStatus.includes('部分支付') ||
      paymentStatus.includes('未支付') ||
      paymentStatus.includes('unpaid') ||
      paymentStatus.includes('partial')
    ) {
      return 'fas fa-credit-card text-red-500 mr-1';
    }

    // 默认显示橙色图标
    return 'fas fa-credit-card text-orange-500 mr-1';
  };

  // 获取支付状态文本
  const getPaymentStatusText = (table: OrderTableListItemModel) => {
    return table.orderSelectResp?.paymentStatusName || '未知状态';
  };

  // 获取支付状态样式类
  const getPaymentStatusClass = (table: OrderTableListItemModel) => {
    const paymentStatus = table.orderSelectResp?.paymentStatusName?.toLowerCase() || '';

    // 已支付状态显示绿色文字
    if (
      paymentStatus.includes('已支付') ||
      paymentStatus.includes('支付成功') ||
      paymentStatus.includes('paid') ||
      paymentStatus.includes('success')
    ) {
      return 'text-green-600 font-semibold';
    }

    // 待支付或部分支付显示红色文字
    if (
      paymentStatus.includes('待支付') ||
      paymentStatus.includes('部分支付') ||
      paymentStatus.includes('未支付') ||
      paymentStatus.includes('unpaid') ||
      paymentStatus.includes('partial')
    ) {
      return 'text-red-600 font-semibold';
    }

    // 默认显示橙色文字
    return 'text-orange-600 font-semibold';
  };

  // 获取桌位状态图标
  const getTableStatusIcon = (table: OrderTableListItemModel) => {
    if (table.tableStatus === 5) {
      return 'fas fa-exclamation-circle text-orange-500 mr-1';
    } else if (table.tableStatus === 8) {
      return 'fas fa-smile text-green-500 mr-1';
    }
    return 'fas fa-clock text-blue-500 mr-1';
  };

  // 获取桌位状态详细文本
  const getTableStatusDetailText = (table: OrderTableListItemModel) => {
    if (table.tableStatus === 5) {
      return '需要确认';
    } else if (table.tableStatus === 8) {
      return '用餐结束';
    }
    return '制作中';
  };

  // 获取桌位状态文本样式类
  const getTableStatusTextClass = (table: OrderTableListItemModel) => {
    if (table.tableStatus === 5) {
      return 'text-orange-600';
    } else if (table.tableStatus === 8) {
      return 'text-green-600';
    }
    return 'text-blue-600';
  };

  // 判断是否显示确认按钮
  const shouldShowConfirmButton = (table: OrderTableListItemModel) => {
    return table.tableStatus === 5; // 待确认状态显示确认按钮
  };

  // 判断是否显示翻台按钮
  const shouldShowFlipButton = (table: OrderTableListItemModel) => {
    return table.tableStatus === 8; // 已完成状态显示翻台按钮
  };

  // 确认订单功能
  const confirmOrder = async (table: OrderTableListItemModel) => {
    if (!confirm(`确定要确认 ${table.tableName} 的订单吗？\n\n确认后订单将发送至厨房开始制作。`)) {
      return;
    }

    currentConfirmTable.value = table;
    showConfirmProgress.value = true;
    confirmProgress.value = 0;
    confirmProgressText.value = '备餐中...';

    // 模拟确认进度
    const steps = [
      { progress: 30, text: '验证订单信息...' },
      { progress: 60, text: '发送至厨房系统...' },
      { progress: 90, text: '更新订单状态...' },
      { progress: 100, text: '确认完成！' },
    ];

    let currentStep = 0;
    const interval = setInterval(async () => {
      if (currentStep < steps.length) {
        confirmProgress.value = steps[currentStep].progress;
        confirmProgressText.value = steps[currentStep].text;

        // 在最后一步调用确认接口
        if (currentStep === steps.length - 1 && table.orderId) {
          try {
            const response = await auditOrder({ orderId: table.orderId });
            if (response.code === 200) {
              showToast(`${table.tableName}订单已确认，已发送至厨房！`);
              // 刷新桌位状态
              if (selectedShopId.value) {
                await fetchOrderTableList(selectedShopId.value);
              }
            } else {
              showToast(response.msg || '确认失败');
            }
          } catch (error) {
            console.error('确认订单失败:', error);
            showToast('确认订单失败，请稍后重试');
          }
        }

        currentStep++;
      } else {
        clearInterval(interval);
        setTimeout(() => {
          showConfirmProgress.value = false;
          currentConfirmTable.value = null;
        }, 500);
      }
    }, 500);
  };

  // 翻台功能
  const flipTable = async (table: OrderTableListItemModel) => {
    if (
      !confirm(`确定要翻台 ${table.tableName} 吗？\n\n翻台后将清理桌面、重置状态，等待下一批客人。`)
    ) {
      return;
    }

    if (!table.orderId) {
      showToast('订单信息不完整，无法翻台');
      return;
    }

    currentFlipTable.value = table;
    showFlipProgress.value = true;
    flipProgress.value = 0;
    flipProgressText.value = '清理中...';

    // 模拟翻台进度
    const steps = [
      { progress: 30, text: '清理餐具...' },
      { progress: 60, text: '消毒桌面...' },
      { progress: 90, text: '整理桌椅...' },
      { progress: 100, text: '翻台完成！' },
    ];

    let currentStep = 0;
    const interval = setInterval(async () => {
      if (currentStep < steps.length) {
        flipProgress.value = steps[currentStep].progress;
        flipProgressText.value = steps[currentStep].text;

        // 在最后一步调用翻台接口
        if (currentStep === steps.length - 1) {
          try {
            const response = await completeOrder({ orderId: table.orderId });
            if (response.code === 200) {
              showToast(`${table.tableName}翻台完成，已准备就绪！`);
              // 刷新桌位状态
              if (selectedShopId.value) {
                await fetchOrderTableList(selectedShopId.value);
              }
            } else {
              showToast(response.msg || '翻台失败');
            }
          } catch (error) {
            console.error('翻台失败:', error);
            showToast('翻台失败，请稍后重试');
          }
        }

        currentStep++;
      } else {
        clearInterval(interval);
        setTimeout(() => {
          showFlipProgress.value = false;
          currentFlipTable.value = null;
        }, 500);
      }
    }, 800);
  };

  const navigateToNewOrder = async (table: OrderTableListItemModel) => {
    if (isTableNavigationPending.value) return;

    if (!table.tableId || !table.shopId || !table.tableName) {
      showToast('桌位信息不完整，请刷新后重试');
      return;
    }

    if (selectedShopId.value !== table.shopId) {
      showToast('桌位信息已更新，请重新选择');
      orderTableList.value = [];
      if (selectedShopId.value !== null) {
        await fetchOrderTableList(selectedShopId.value);
      }
      return;
    }

    isTableNavigationPending.value = true;
    try {
      await router.push({
        path: '/orderNew',
        query: {
          tableNumber: table.tableId,
          tableName: table.tableName,
          tableType: table.tableType,
          tableTag: table.tableTag || '',
          shopId: table.shopId,
          shopName: getShopNameById(table.shopId),
          cartType: table.cartType || 1,
        },
      });
    } catch (error) {
      console.error('进入点餐页面失败:', error);
      showToast('进入点餐页面失败，请重试');
    } finally {
      isTableNavigationPending.value = false;
    }
  };

  // 点击桌位卡片事件
  const handleTableClick = (table: OrderTableListItemModel) => {
    if (isTableNavigationPending.value) return;

    // 如果是禁用或清理中的桌位，显示提示
    if (table.tableStatus === 3) {
      showToast('此桌位暂不可用');
      return;
    }
    if (table.tableStatus === 4) {
      showToast('此桌位正在清理中');
      return;
    }

    if (table.tableStatus === 0) {
      // 未点餐状态，跳转到点餐页面
      void navigateToNewOrder(table);
    } else if (table.tableStatus === 10) {
      // 已预订状态，确认开始点餐
      if (confirm(`${table.tableName}已被预订，是否确认开始点餐？`)) {
        void navigateToNewOrder(table);
      }
    } else if (table.tableStatus && table.tableStatus > 0 && table.tableStatus < 9) {
      // 已点餐状态，跳转到订单详情页面
      router.push({
        path: '/orderDetails',
        query: {
          orderId: table.orderId,
          tableNumber: table.tableId,
          tableName: table.tableName,
          shopId: table.shopId,
          shopName: getShopNameById(table.shopId as number),
        },
      });
    }
  };

  // 添加座位按钮事件
  const handleAddTable = () => {
    showToast('添加新桌位功能将在下一版本推出');
  };

  // 显示提示消息
  const showToast = (message: string) => {
    // 创建toast元素
    const toast = document.createElement('div');
    toast.className = 'toast-message';
    toast.textContent = message;
    toast.style.cssText = `
      position: fixed;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      z-index: 1000;
      font-size: 16px;
      font-weight: 500;
    `;

    document.body.appendChild(toast);

    setTimeout(() => {
      if (document.body.contains(toast)) {
        document.body.removeChild(toast);
      }
    }, 2000);
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedShopId).value = $event)),
          class: "restaurant-dropdown",
          disabled: "",
          onChange: onShopChange
        }, [
          (shopList.value.length === 0)
            ? (_openBlock(), _createElementBlock("option", _hoisted_4, "加载中..."))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
            return (_openBlock(), _createElementBlock("option", {
              key: shop.shopId,
              value: shop.shopId
            }, _toDisplayString(shop.shopName), 9, _hoisted_5))
          }), 128))
        ], 544), [
          [_vModelSelect, selectedShopId.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_unref(currentEmployeeId))
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " 工号: " + _toDisplayString(_unref(currentEmployeeId)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "nav-menu-btn",
            onClick: toggleNavMenu
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "fas fa-bars" }, null, -1),
            _createTextVNode(" 菜单 ", -1),
            _createElementVNode("i", { class: "fas fa-chevron-down ml-1" }, null, -1)
          ])),
          _createElementVNode("div", {
            class: _normalizeClass(["nav-menu", { show: showNavMenu.value }])
          }, [
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToTableManage
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fas fa-table" }, null, -1),
              _createTextVNode(" 桌位管理 ", -1)
            ])),
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToKitchen
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fas fa-utensils" }, null, -1),
              _createTextVNode(" 订单出餐 ", -1)
            ])),
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToOrderHistory
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fas fa-receipt" }, null, -1),
              _createTextVNode(" 订单查询 ", -1)
            ])),
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToDishAssignment
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "fas fa-tasks" }, null, -1),
              _createTextVNode(" 菜品分配 ", -1)
            ])),
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToHistory
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fas fa-history" }, null, -1),
              _createTextVNode(" 出餐历史 ", -1)
            ])),
            _createElementVNode("button", {
              class: "nav-menu-item",
              onClick: goToFoodManage
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fas fa-utensils" }, null, -1),
              _createTextVNode(" 菜品管理 ", -1)
            ]))
          ], 2)
        ]),
        _createElementVNode("button", {
          class: "text-white mr-4",
          onClick: toggleLanguage
        }, _cache[8] || (_cache[8] = [
          _createElementVNode("i", { class: "fas fa-language text-2xl" }, null, -1)
        ])),
        _cache[9] || (_cache[9] = _createElementVNode("button", { class: "mr-4" }, [
          _createElementVNode("i", { class: "fas fa-search text-white text-xl" })
        ], -1)),
        _cache[10] || (_cache[10] = _createElementVNode("button", null, [
          _createElementVNode("i", { class: "fas fa-bell text-white text-xl" })
        ], -1))
      ])
    ]),
    _createElementVNode("div", { class: "refresh-bar" }, [
      _createElementVNode("button", { onClick: refreshTableStatus }, "点击此处【刷新】点餐状态")
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"legend-list\" data-v-0783cf38><div class=\"legend-item\" data-v-0783cf38><div class=\"legend-dot legend-dot-blue\" data-v-0783cf38></div><span data-v-0783cf38>尚未点餐</span></div><div class=\"legend-item\" data-v-0783cf38><div class=\"legend-dot legend-dot-green\" data-v-0783cf38></div><span data-v-0783cf38>已点餐</span></div><div class=\"legend-item\" data-v-0783cf38><div class=\"legend-dot legend-dot-yellow\" data-v-0783cf38></div><span data-v-0783cf38>已预订</span></div><div class=\"legend-item\" data-v-0783cf38><div class=\"legend-dot legend-dot-gray\" data-v-0783cf38></div><span data-v-0783cf38>已禁用</span></div><div class=\"legend-item\" data-v-0783cf38><div class=\"legend-dot legend-dot-pink\" data-v-0783cf38></div><span data-v-0783cf38>清理中</span></div></div>", 1)),
      _createElementVNode("div", _hoisted_11, [
        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-clock mr-2" }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(lastRefreshTime.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderTableList.value, (table) => {
          return (_openBlock(), _createElementBlock("div", {
            key: table.tableId,
            class: _normalizeClass(["table-card glass-card", getTableStatusClass(table.tableStatus)]),
            onClick: ($event: any) => (handleTableClick(table))
          }, [
            (shouldShowConfirmButton(table))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "confirm-order-btn",
                  title: "确认订单",
                  onClick: _withModifiers(($event: any) => (confirmOrder(table)), ["stop"])
                }, _cache[13] || (_cache[13] = [
                  _createElementVNode("i", { class: "fas fa-check" }, null, -1)
                ]), 8, _hoisted_15))
              : _createCommentVNode("", true),
            (shouldShowFlipButton(table))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "flip-table-btn",
                  title: "翻台",
                  onClick: _withModifiers(($event: any) => (flipTable(table)), ["stop"])
                }, _cache[14] || (_cache[14] = [
                  _createElementVNode("i", { class: "fas fa-sync-alt" }, null, -1)
                ]), 8, _hoisted_16))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, _toDisplayString(table.tableName), 1),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", {
                class: _normalizeClass(["status-badge", { 'text-red-600': table.tableStatus === 1 }])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(getStatusIcon(table.tableStatus))
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(table.tableStatusName || getStatusText(table.tableStatus)), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_19, [
              (table.tableStatus === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-users text-gray-500" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(table.seatsDesc || (table.seats ? table.seats + '人桌' : '2-4人桌')), 1)
                  ]))
                : _createCommentVNode("", true),
              (table.tableStatus === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "fas fa-clock text-gray-500" }, null, -1),
                    _createElementVNode("span", null, "空闲中", -1)
                  ])))
                : _createCommentVNode("", true),
              (isOccupiedTable(table))
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-users text-green-600" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(getPersonCount(table)) + "人用餐", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-clock text-green-600" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(getOpenTime(table)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("i", {
                          class: _normalizeClass(getPaymentStatusIcon(table))
                        }, null, 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(getPaymentStatusClass(table))
                        }, _toDisplayString(getPaymentStatusText(table)), 3)
                      ]),
                      _createElementVNode("div", _hoisted_29, "¥" + _toDisplayString(getTotalAmount(table)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (table.tableStatus === 10)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _cache[19] || (_cache[19] = [
                    _createStaticVNode("<div class=\"table-info-row-occupied\" data-v-0783cf38><div class=\"flex items-center\" data-v-0783cf38><i class=\"fas fa-users text-yellow-600\" data-v-0783cf38></i><span data-v-0783cf38>6人预订</span></div><div class=\"text-yellow-600 font-semibold\" data-v-0783cf38>18:30</div></div><div class=\"table-info-row-occupied\" data-v-0783cf38><div class=\"flex items-center text-xs\" data-v-0783cf38><i class=\"fas fa-user text-yellow-600\" data-v-0783cf38></i><span data-v-0783cf38>李先生</span></div><div class=\"flex items-center text-xs\" data-v-0783cf38><i class=\"fas fa-phone text-gray-500\" data-v-0783cf38></i><span data-v-0783cf38>138****8888</span></div></div><div class=\"flex items-center text-xs\" data-v-0783cf38><i class=\"fas fa-clock text-orange-500\" data-v-0783cf38></i><span data-v-0783cf38>2小时后到达</span></div>", 3)
                  ])))
                : _createCommentVNode("", true),
              (table.tableStatus === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[20] || (_cache[20] = [
                    _createElementVNode("div", { class: "table-info-row" }, [
                      _createElementVNode("i", { class: "fas fa-exclamation-triangle text-red-500" }),
                      _createElementVNode("span", null, "桌椅维修中")
                    ], -1),
                    _createElementVNode("div", { class: "flex items-center text-xs" }, [
                      _createElementVNode("i", { class: "fas fa-clock text-gray-500" }),
                      _createElementVNode("span", null, "预计明日可用")
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              (table.tableStatus === 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[21] || (_cache[21] = [
                    _createStaticVNode("<div class=\"table-info-row\" data-v-0783cf38><i class=\"fas fa-user-tie text-pink-600\" data-v-0783cf38></i><span data-v-0783cf38>王清洁员</span></div><div class=\"flex items-center justify-between\" data-v-0783cf38><div class=\"flex items-center text-xs\" data-v-0783cf38><i class=\"fas fa-clock text-pink-500\" data-v-0783cf38></i><span data-v-0783cf38>15:30开始</span></div><div class=\"text-pink-600 font-semibold text-xs\" data-v-0783cf38>10分钟后完成</div></div>", 2)
                  ])))
                : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_14))
        }), 128)),
        _createElementVNode("div", {
          class: "add-table-card glass-card",
          onClick: handleAddTable
        }, _cache[22] || (_cache[22] = [
          _createElementVNode("div", { class: "add-table-content" }, [
            _createElementVNode("i", { class: "fas fa-plus" }),
            _createElementVNode("div", null, "添加座位")
          ], -1)
        ]))
      ])
    ]),
    (showFlipProgress.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "mb-4" }, [
                _createElementVNode("i", { class: "fas fa-sync-alt text-4xl text-blue-500 animate-spin" })
              ], -1)),
              _createElementVNode("h3", _hoisted_36, _toDisplayString(currentFlipTable.value?.tableName) + "翻台中...", 1),
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-gray-600 mb-4" }, "正在清理桌面，请稍候", -1)),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", {
                  class: "progress-bar-fill",
                  style: _normalizeStyle({ width: flipProgress.value + '%' })
                }, null, 4)
              ]),
              _createElementVNode("p", _hoisted_38, _toDisplayString(flipProgressText.value), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showConfirmProgress.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mb-4" }, [
                _createElementVNode("i", { class: "fas fa-check-circle text-4xl text-green-500 animate-pulse" })
              ], -1)),
              _createElementVNode("h3", _hoisted_42, _toDisplayString(currentConfirmTable.value?.tableName) + "订单确认中...", 1),
              _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-gray-600 mb-4" }, "正在发送至厨房系统", -1)),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", {
                  class: "progress-bar-fill bg-green-500",
                  style: _normalizeStyle({ width: confirmProgress.value + '%' })
                }, null, 4)
              ]),
              _createElementVNode("p", _hoisted_44, _toDisplayString(confirmProgressText.value), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})